import React, { useEffect, useState } from 'react';
import { styled, keyframes } from '@mui/system';

const bounce = keyframes`
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(0, -15px, 0);
  }
`;

const Wrapper = styled('main')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: '#ffffff', // white background
  fontFamily: '"Monotype Corsiva Regular", Monotype Corsiva, serif',
  minHeight: '100vh',
  width: '100vw',
});

const LetterContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const P = styled('p')({
  fontSize: '8em',
  fontWeight: 'bold',
  color: '#e52e71', // still stylish on white background
  margin: 0,
  lineHeight: 1,
});

const BounceDot = styled(P)({
  animation: `${bounce} 0.4s infinite alternate`,
  marginBottom: '-0.5em',
});

const Adjust = styled(P)({});

const AppTitle = styled('p')({
  marginTop: '0.3em',
  fontSize: '1.5em',
  color: '#e52e71',
});

const PageLoader = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <Wrapper>
        <LetterContainer>
          <BounceDot>.</BounceDot>
          <Adjust>ı</Adjust>
          <AppTitle>PaymentApp</AppTitle>
        </LetterContainer>
      </Wrapper>
    );
  }

  return <>{children}</>;
};

export default PageLoader;
